// // Custom cursor, if required.
// // This implementation uses GSAP to update the position of the cursor.
//

function initCustomCursor() {
    const cursor = document.querySelector("#custom-cursor");
    gsap.set(cursor, {
        xPercent: -50,
        yPercent: -50
    });

    const pos = {
        x: window.innerWidth / 2,
        y: window.innerHeight / 2
    };
    const mouse = {
        x: pos.x,
        y: pos.y
    };
    const speed = 0.35;

    const xSet = gsap.quickSetter(cursor, "x", "px");
    const ySet = gsap.quickSetter(cursor, "y", "px");


    gsap.set(cursor, {
        opacity: 0
    })

    function mousemoveFunction(e) {
        mouse.x = e.x;
        mouse.y = e.y;
    }

    function tickerUpdate() {
        var dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());

        pos.x += (mouse.x - pos.x) * dt;
        pos.y += (mouse.y - pos.y) * dt;
        xSet(pos.x);
        ySet(pos.y);
    }


    // if ('ontouchstart' in window) {
    //     cursor.style.display = 'none';
    // }

// Only show on the section with the glowing background
    let cursorSections = document.querySelectorAll(".has-definition em");
// var cursorSectionPolicy = document.querySelector(".privacy-policy");

// Check if custom cursor section exists on page
    if (cursorSections) {
        let hovered = 0;

        // for each cursor section, add the mousemove event

        cursorSections.forEach(cursorHover => {
            cursorHover.onmouseenter = function () {
                cursorHover.addEventListener("mousemove", mousemoveFunction);
                gsap.ticker.add(tickerUpdate)
                gsap.to(cursor, {opacity: 1})
            }

            cursorHover.onmouseleave = function () {
                cursorHover.removeEventListener("mousemove", mousemoveFunction);
                gsap.ticker.remove(tickerUpdate)
                gsap.to(cursor, {opacity: 0})
            }
        });


        document.body.addEventListener("mousemove", mousemoveFunction);
        gsap.ticker.add(tickerUpdate)

        // -------------------
        // Cursor events
        // -------------------

        // Grow cursor when hovering over links
        document.querySelectorAll('a').forEach(o => {
            o.addEventListener('mouseover', () => {
                hovered = 1;
                gsap.to(cursor, {
                    scale: 2,
                })
                cursor.classList.add('hover');
            });

            o.addEventListener('mouseleave', () => {
                hovered = 0;
                gsap.to(cursor, {
                    scale: 1,
                })
                cursor.classList.remove('hover');
            });
        });

        // Click event
        document.body.addEventListener("mousedown", function (event) {
            if (hovered === 1) {
                gsap.to(cursor, {
                    scale: 0.8,
                })

            } else {
                gsap.to(cursor, {
                    scale: 0.9,
                })
            }

        }, false);

        // Click release event
        document.body.addEventListener("mouseup", function (event) {
            //If the cursor is currently hovered over an interactive element
            //when releasing click
            if (hovered === 1) {
                gsap.to(cursor, {
                    scale: 2,
                })

            } else {
                gsap.to(cursor, {
                    scale: 1,
                })
            }

        });
    }


} // End initCustomCursor


// Definition popup
/* Script for popover positioning */
// (function(selector, horizontalOffset, verticalOffset) {
//     var items;
//
//     selector = selector || '.has-definiton em';
//     horizontalOffset = horizontalOffset || 5;
//     verticalOffset = verticalOffset || 5;
//
//     items = document.querySelectorAll(selector);
//     items = Array.prototype.slice.call(items);
//
//     items.forEach(function(item) {
//         // Every time the pointer moves over the element the
//         //  CSS-rule in overwritten with new values for
//         //  top and left.
//         item.addEventListener('mousemove', function(e) {
//             let countCssRules = document.styleSheets[0].cssRules.length;
//             var rightSpace = document.body.clientWidth - e.pageX;
//             if( rightSpace > 300 ){
//                 var newRule = selector +
//                     ':hover .popover-content {  ' +
//                     'right:auto; left: ' + (horizontalOffset + e.offsetX) + 'px; ' +
//                     'top: ' +  (e.offsetY + verticalOffset) + 'px; }';
//             }else{
//                 var newRule = selector +
//                     ':hover .popover-content {  ' +
//                     'left:auto; right: ' + (item.offsetWidth - e.offsetX) + 'px; ' +
//                     'top: ' +  (e.offsetY + verticalOffset) + 'px; }';
//             }
//
//
//             document.styleSheets[0].insertRule(newRule, countCssRules);
//         });
//     });
// })('.has-definiton em', 10, 5);


function initDefinitionTooltips() {
    // Collect all elements with "shape" class
    let changed = 0;
    let phraseText = '';
    const definitionEms = document.querySelectorAll('.has-definition em')

    // console.log(definitionEms);

// Get the tooltip container
    const tooltip = document.getElementById('definition-tooltip');

// Add events for tooltip creation
    for (var i = 0; i < definitionEms.length; i++) {
        definitionEms[i].addEventListener('mousemove', showTooltip);
        definitionEms[i].addEventListener('mouseout', hideTooltip);

        phraseText = definitionEms[i].innerHTML.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()?]/g,"");        //remove punctuation from phrase
        // phraseText = phraseText
        definitionEms[i].setAttribute('data-phrase', phraseText);
    }

    function showTooltip(evt) {
        //console.log('hover');

        // console.log('hover');
        // console.log(evt.target.parentNode.getAttribute( "data-definition"));

        changed = 1;

        // Set tooltip to visible
        tooltip.style.visibility = "visible"

        // Updates position of the tooltip when the pointer is moving
        // (Mouse coordinates relative to client area + arbitrary offset)
        // tooltip.style.top = (evt.pageY - 50) + "px";
        // tooltip.style.left = (evt.clientX + 90) + "px";
        tooltip.style.top = (evt.pageY - 0) + "px";
        tooltip.style.left = (evt.clientX + 0) + "px";

        // Change text inside the tooltip getting text from the relative attribute on the hovered div
        // tooltip.innerHTML = evt.target.parent.getAttributeNS(null, "data-definition");
        // tooltip.innerHTML = evt.target.getAttributeNS(null, "data-definition");

        //remove punctuation from phrase
        // let phraseText = evt.target.innerHTML.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()?]/g,"");
        // let phraseText = evt.target.innerHTML.replace(/<br>|[.,\/#!$%\^&\*;:{}=\-_`~()?]|[\n]/g,"");
        // let phraseText = evt.target.innerHTML.replace(/<br>|[.,\/#!$%\^&\*;:{}=\-_`~()?]|[\n]/g,"").replace(/'S$/i, "");
        // let phraseText = evt.target.innerHTML.replace(/<br>|[.,\/#!$%\^&\*;:{}=\-_`~()?]|[\n]/g,"").replace(/'S/gi, "");
        let phraseText = evt.target.innerHTML.replace(/<br>|[.,\/#!$%\^&\*;:{}=\-_`~()?]|[\n]|’S/gi,"");




        tooltip.querySelector('.phrase').innerHTML = phraseText + ':';
        tooltip.querySelector('.definition').innerHTML = evt.target.parentNode.getAttribute("data-definition");
        // if (evt.target.parentNode.getAttribute("data-style")) {
            tooltip.classList.add(evt.target.parentNode.getAttribute("data-style"));
        // }
    }

// Shut down tooltip when mouse pointer leaves the shape
    function hideTooltip() {
        tooltip.style.visibility = "hidden"

        setTimeout(function () {
            tooltip.removeAttribute("class");
        }, 500);
    }
}

//document loaded
document.addEventListener("DOMContentLoaded", function (event) {
    initDefinitionTooltips();
    initCustomCursor();
});